import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../components/style.css';
import schoolImage from "../assets/images/school.jpg";
import CryptoJS from "crypto-js";
import loadingspinner from '../assets/images/loading.jpg.gif'


const DB_NAME = 'SchoolManagementDB';
const STUDENT_STORE = 'studentData';
const SCHOOL_STORE = 'schoolData';
const ATTENDANCE_STORE = 'attendance';
const DEFAULTSETTING_STORE = 'defaultSettings';
const INVENTORY_STORE = 'inventory';
const LEAVING_CERTIFICATE_STORE = 'leavedStd';
const BONAFIDE_CERTIFICATE_STORE = 'bonafideStd';
const KIRD_STORE = 'kirdWithFeeattach';
const DB_VERSION = 1;


function LoginForm() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [udiseNumber, setUdiseNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [language, setschoollanguage] = useState(localStorage.getItem('language') || 'English');
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const navigate = useNavigate();
  const [udiseOptions, setUdiseOptions] = useState([]);
  const [savingData, setSavingData] = useState(false);


  const [department, setDepartment] = useState('');
  const [departmentOptions, setDepartmentOptions] = useState([]);


  const normalizeUdise = (udise) => {
    return String(udise).trim();
  };

  const normalizeClassName = (firebaseClassKey) => {
    if (!firebaseClassKey || typeof firebaseClassKey !== 'string') return '';

    let str = firebaseClassKey.trim().toUpperCase();

    // Remove common prefixes
    str = str.replace(/^(CLASS|STD|SECTION|इयत्ता|इ\.)\s*/i, '').trim();
    // Remove common suffixes
    str = str.replace(/\s*(CLASS|STD)$/i, '').trim();

    // Comprehensive mapping for Roman numerals, Marathi names, Ordinals, and Digits
    const classMapping = {
      // 1st / Class 1 / Class I / Marathi
      '1': '1', '1ST': '1', 'FIRST': '1', 'I': '1', 'पहिली': '1', '१': '1', '१ ली': '1', '1 ली': '1', '1ST STD': '1',
      // 2nd / Class 2 / Class II / Marathi
      '2': '2', '2ND': '2', 'SECOND': '2', 'II': '2', 'दुसरी': '2', '२': '2', '२ री': '2', '2 री': '2', '2ND STD': '2',
      // 3rd / Class 3 / Class III / Marathi
      '3': '3', '3RD': '3', 'THIRD': '3', 'III': '3', 'तिसरी': '3', '३': '3', '३ री': '3', '3 री': '3', '3RD STD': '3',
      // 4th / Class 4 / Class IV / Marathi
      '4': '4', '4TH': '4', 'FOURTH': '4', 'IV': '4', 'चौथी': '4', '४': '4', '४ थी': '4', '4 थी': '4', '4TH STD': '4',
      // 5th / Class 5 / Class V / Marathi
      '5': '5', '5TH': '5', 'FIFTH': '5', 'V': '5', 'पाचवी': '5', '५': '5', '५ वी': '5', '5 वी': '5', '5TH STD': '5',
      // 6th / Class 6 / Class VI / Marathi
      '6': '6', '6TH': '6', 'SIXTH': '6', 'VI': '6', 'सहावी': '6', '६': '6', '६ वी': '6', '6 वी': '6', '6TH STD': '6',
      // 7th / Class 7 / Class VII / Marathi
      '7': '7', '7TH': '7', 'SEVENTH': '7', 'VII': '7', 'सातवी': '7', '७': '7', '७ वी': '7', '7 वी': '7', '7TH STD': '7',
      // 8th / Class 8 / Class VIII / Marathi
      '8': '8', '8TH': '8', 'EIGHTH': '8', 'VIII': '8', 'आठवी': '8', '८': '8', '८ वी': '8', '8 वी': '8', '8TH STD': '8',
      // 9th / Class 9 / Class IX / Marathi
      '9': '9', '9TH': '9', 'NINTH': '9', 'IX': '9', 'नववी': '9', '९': '9', '९ वी': '9', '9 वी': '9', '9TH STD': '9',
      // 10th / Class 10 / Class X / Marathi
      '10': '10', '10TH': '10', 'TENTH': '10', 'X': '10', 'दहावी': '10', '१०': '10', '१० वी': '10', '10 वी': '10', '10TH STD': '10',
      // 11th / Class 11 / Class XI / Marathi
      '11': '11', '11TH': '11', 'ELEVENTH': '11', 'XI': '11', 'अकरावी': '11', '११': '11', '११ वी': '11', '11 वी': '11', '11TH STD': '11',
      // 12th / Class 12 / Class XII / Marathi
      '12': '12', '12TH': '12', 'TWELFTH': '12', 'XII': '12', 'बारावी': '12', '१२': '12', '१२ वी': '12', '12 वी': '12', '12TH STD': '12',
      // Kindergarten / Nursery
      'JR KG': 'JR KG', 'JR. KG': 'JR KG', 'JUNIOR KG': 'JR KG', 'JUNIOR K.G.': 'JR KG', 'ज्युनियर के जी': 'JR KG', 'ज्युनियर केजी': 'JR KG',
      'SR KG': 'SR KG', 'SR. KG': 'SR KG', 'SENIOR KG': 'SR KG', 'SENIOR K.G.': 'SR KG', 'सिनियर के जी': 'SR KG', 'सिनियर केजी': 'SR KG',
      'NURSERY': 'NURSERY', 'नर्सरी': 'NURSERY', 'PLAYGROUP': 'PLAYGROUP', 'PRE-K': 'PRE-K'
    };

    if (classMapping[str]) {
      return classMapping[str];
    }

    // Fallback: strip extra punctuation and check again
    const cleanStr = str.replace(/[^A-Z0-9\u0900-\u097F]/g, ' ').replace(/\s+/g, ' ').trim();
    if (classMapping[cleanStr]) {
      return classMapping[cleanStr];
    }

    return str;
  };

  const initializeDB = () => {
    return new Promise((resolve, reject) => {
      try {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        
        request.onerror = (event) => {
          event.preventDefault();
          console.error("IndexedDB error:", event.target.error);
          reject("Error opening IndexedDB");
        };
        
        request.onsuccess = (event) => {
          const db = event.target.result;
          resolve(db);
        };
        
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          
          if (!db.objectStoreNames.contains(STUDENT_STORE)) {   
            db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
          }
          if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
            db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
          }
          if (!db.objectStoreNames.contains(ATTENDANCE_STORE)) {
            db.createObjectStore(ATTENDANCE_STORE, { autoIncrement: true });
          }
          if (!db.objectStoreNames.contains(DEFAULTSETTING_STORE)) {
            db.createObjectStore(DEFAULTSETTING_STORE,  { keyPath: "id" });
          }
          if (!db.objectStoreNames.contains(INVENTORY_STORE)) {
            db.createObjectStore(INVENTORY_STORE, { keyPath: "key" });
          }
          if (!db.objectStoreNames.contains(LEAVING_CERTIFICATE_STORE)) {
            db.createObjectStore(LEAVING_CERTIFICATE_STORE, { keyPath: "serialNo" });
          }
          if (!db.objectStoreNames.contains(BONAFIDE_CERTIFICATE_STORE)) {
            db.createObjectStore(BONAFIDE_CERTIFICATE_STORE, { keyPath: "serialNo" });
          }
          if (!db.objectStoreNames.contains(KIRD_STORE)) {
            db.createObjectStore(KIRD_STORE, { keyPath: "id" }); 
          }
        };
      } catch (err) {
        console.error("IndexedDB open threw synchronous error:", err);
        reject(err);
      }
    });
  };
  const clearIndexedDB = async () => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction([STUDENT_STORE, SCHOOL_STORE, ATTENDANCE_STORE, DEFAULTSETTING_STORE, INVENTORY_STORE, KIRD_STORE], "readwrite");
  
      // Clear all object stores
      const studentStore = transaction.objectStore(STUDENT_STORE);
      const schoolStore = transaction.objectStore(SCHOOL_STORE);
      const attendanceStore = transaction.objectStore(ATTENDANCE_STORE);
      const defaultSettingsStore = transaction.objectStore(DEFAULTSETTING_STORE);
      const inventoryStore = transaction.objectStore(INVENTORY_STORE);
      const kirdfeestore = transaction.objectStore(KIRD_STORE);
  
      // Clear each store
      await Promise.all([
        studentStore.clear(),
        schoolStore.clear(),
        attendanceStore.clear(),
        defaultSettingsStore.clear(),
        inventoryStore.clear(),
        kirdfeestore.clear(),
      ]);
  
      transaction.oncomplete = () => {
        console.log("All IndexedDB data cleared successfully.");
      };
  
      transaction.onerror = (e) => {
        console.error("Error clearing IndexedDB data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for clearing data:", error);
    }
  };
  const storeSchoolData = async (schoolData, selectedDept = null) => {
  try {
    const db = await initializeDB();
    const transaction = db.transaction(SCHOOL_STORE, "readwrite");
    const store = transaction.objectStore(SCHOOL_STORE);
    
    console.log("Storing school data in IndexedDB:", schoolData);
    
    let completeSchoolData = {
      udiseNumber: schoolData.udiseNumber || udiseNumber,
      ...schoolData,
      signature: schoolData.signature || "" // Make sure signature is included
    };

    if (selectedDept && schoolData.department && schoolData.department[selectedDept]) {
      const deptData = schoolData.department[selectedDept];
      completeSchoolData = {
        ...completeSchoolData,
        schoolName: deptData.schoolName || completeSchoolData.schoolName,
        schoolLogo: deptData.schoolLogo || completeSchoolData.schoolLogo,
        language: deptData.language || completeSchoolData.language || "English",
        address: deptData.address || completeSchoolData.address || "",
        taluka: deptData.taluka || completeSchoolData.taluka || "",
        jilha: deptData.jilha || completeSchoolData.jilha || "",
        email: deptData.email || completeSchoolData.email || "",
        boardName: deptData.boardName || completeSchoolData.boardName || "",
        boardType: deptData.boardType || completeSchoolData.boardType || "",
        madhyam: deptData.madhyam || completeSchoolData.madhyam || "",
        mobileNumber: deptData.mobileNumber || completeSchoolData.mobileNumber || "",
        sansthaName: deptData.sansthaName || completeSchoolData.sansthaName || "",
        schoolLogo2: deptData.schoolLogo2 || completeSchoolData.schoolLogo2 || "",
        signature: deptData.signature || completeSchoolData.signature || "",
        manyataKramank: deptData.manyataKramank || completeSchoolData.manyataKramank || "",
        indexNumber: deptData.indexNumber || completeSchoolData.indexNumber || "",
        schoolCode: deptData.schoolCode || completeSchoolData.schoolCode || "",
        sanlagnataKramank: deptData.sanlagnataKramank || completeSchoolData.sanlagnataKramank || "",
        state: deptData.state || completeSchoolData.state || "",
        telephoneNumber: deptData.telephoneNumber || completeSchoolData.telephoneNumber || "",
        department: selectedDept,
        isDepartmentData: true
      };
    }
    
    const request = store.put(completeSchoolData);
    
    request.onsuccess = () => {
      console.log("School data stored successfully");
    };
    
    request.onerror = (e) => {
      console.error("Error storing school data:", e.target.error);
    };
  } catch (error) {
    console.error("Error initializing DB for school data:", error);
  }
};
  

  const storeStudentData = async (studentData) => {
    try {
      const db = await initializeDB();

      // Clear STUDENT_STORE first so old department data is deleted
      await new Promise((resolve, reject) => {
        const clearTransaction = db.transaction(STUDENT_STORE, "readwrite");
        const clearStore = clearTransaction.objectStore(STUDENT_STORE);
        const clearRequest = clearStore.clear();
        clearRequest.onsuccess = () => resolve();
        clearRequest.onerror = (e) => reject(e.target.error);
      });

      // Prepare student data - add unique IDs if they don't exist
      const preparedData = Object.entries(studentData).map(([key, student]) => {
        if (student === null) return null;
        
       // Trim all relevant fields
  const currentClass = (student.currentClass || "").trim();
  const division = (student.division || "").trim();
  const serialNo = (student.serialNo || "").toString().trim();
  const id = (student.id || "").trim();

  return { 
    ...student,
    currentClass,
    division,
    serialNo,
    id: id || `${currentClass}-${division || ''}-${serialNo}`
  };
}).filter(item => item !== null);
      
      // Process in batches of 100 records
      const BATCH_SIZE = 100;
      
      // Function to store a batch
      const storeBatch = (batch) => {
        return new Promise((resolve, reject) => {
          const transaction = db.transaction(STUDENT_STORE, "readwrite");
          const store = transaction.objectStore(STUDENT_STORE);
          
          transaction.oncomplete = () => resolve();
          transaction.onerror = (e) => reject(e.target.error);
          
          batch.forEach(student => {
            store.put(student);
          });
        });
      };
      
      for (let i = 0; i < preparedData.length; i += BATCH_SIZE) {
        const batch = preparedData.slice(i, i + BATCH_SIZE);
        await storeBatch(batch);
      }
      
      storeSerialNoSummary(preparedData);
      
      // console.log(`Successfully stored ${preparedData.length} student records in IndexedDB`);
      return true;
    } catch (error) {
      console.error("Error storing student data in IndexedDB:", error);
      return false;
    }
  };
const storeKirdData = async (kirdData) => {
  try {
    const db = await initializeDB();
    const transaction = db.transaction(KIRD_STORE, "readwrite");
    const store = transaction.objectStore(KIRD_STORE);
    
    const request = store.put(kirdData); // Assuming kirdData has a unique id

    request.onsuccess = () => {
      console.log("Kird data stored successfully");
    };
    
    request.onerror = (e) => {
      console.error("Error storing kird data:", e.target.error);
    };
  } catch (error) {
    console.error("Error initializing DB for kird data:", error);
  }
};

  
  const storeAttendanceData = async (attendanceData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(ATTENDANCE_STORE, "readwrite");
      const store = transaction.objectStore(ATTENDANCE_STORE);
  
      Object.keys(attendanceData).forEach((key) => {
        const attendanceRecord = attendanceData[key];
        const studentSerialNumber = key;
  
        store.put({
          srNo: studentSerialNumber, // Use srNo as the key
          Presenty: attendanceRecord // Store the attendance data
        }, studentSerialNumber); // Specify the key
      });
      transaction.oncomplete = () => {
      };
      transaction.onerror = (e) => {
        console.error("Error storing attendance data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for attendance data:", error);
    }
  };
  
  const storeSerialNoSummary = (studentData) => {
    const serialNoData = {};
    
    studentData.forEach((student) => {
      const currentClass = student.currentClass;
      const division = student.division;
      const serialNo = student.serialNo;
      
      if (!serialNoData[currentClass]) {
        serialNoData[currentClass] = {};
      }
      
      if (!serialNoData[currentClass][division]) {
        serialNoData[currentClass][division] = [];
      }
      
      serialNoData[currentClass][division].push(serialNo);
    });
    
    // Store summary in localStorage for quick access
    localStorage.setItem("serialNoData", JSON.stringify(serialNoData));
  };
  const storeDefaultSettingsData = async (defaultSettings) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(DEFAULTSETTING_STORE, "readwrite");
      const store = transaction.objectStore(DEFAULTSETTING_STORE);
      
      // Prepare the data to be stored
      const settingsData = {
        id: 'defaultSettings', // Use a unique key for the settings
        defaultAdmissionClass: defaultSettings.defaultAdmissionClass,
        defaultCurrentClass: defaultSettings.defaultCurrentClass,
        defaultYear: defaultSettings.defaultYear,
        isCollege: defaultSettings.isCollege,
        isDean: defaultSettings.isDean,
        isPrincipal: defaultSettings.isPrincipal,
        isSchool: defaultSettings.isSchool,
      };
  
      const request = store.put(settingsData);
      request.onsuccess = () => {
      };
      
      request.onerror = (e) => {
        console.error("Error storing default settings data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for default settings data:", error);
    }
  };
  
  
  const storeInventoryData = async (inventoryData) => {
    try {
      console.log("inventoryData", inventoryData);
  
      const db = await initializeDB();
      console.log("IndexedDB initialized");
  
      const transaction = db.transaction(INVENTORY_STORE, "readwrite");
      console.log("Transaction created");
  
      const store = transaction.objectStore(INVENTORY_STORE);
      console.log("Object store retrieved");
  
      // Clear existing inventory data
      store.clear();
      console.log("Existing inventory data cleared");
  
      // Store inventory data
      Object.keys(inventoryData).forEach((key, index) => {
        store.put({ id: index + 1, key, value: inventoryData[key] });
        console.log(`Inventory data stored for key: ${key}`);
      });
  
      transaction.oncomplete = () => {
        console.log("Transaction completed");
      };
  
      transaction.onerror = (e) => {
        console.error("Error storing inventory data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for inventory data:", error);
    }
  };
  
const storeAttachFeeData = async (attachFeeData) => {
  try {
    const db = await initializeDB();
    const transaction = db.transaction(KIRD_STORE, "readwrite");
    const store = transaction.objectStore(KIRD_STORE);
    
    // Clear existing attachFeeData data
    await store.clear();

    // Transform and store attachFeeData
    Object.keys(attachFeeData).forEach((key) => {
      const data = attachFeeData[key];
      const formattedData = {
        id: key, // Use the key as the id
        kirdType: data.kirdType,
        creditKhate: data.creditKhate,
        debitKhate: data.debitKhate,
        typeofattach: data.typeofattach
      };
      store.put(formattedData);
      console.log(`attachFeeData stored for key: ${key}`);
    });

    transaction.oncomplete = () => {
      console.log("Transaction completed for attachFeeData");
    };

    transaction.onerror = (e) => {
      console.error("Error storing attachFeeData data:", e.target.error);
    };
  } catch (error) {
    console.error("Error initializing DB for attachFeeData data:", error);
  }
};




  const storeLeavingCertificateData = async (leavingCertificateData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(LEAVING_CERTIFICATE_STORE, "readwrite");
      const store = transaction.objectStore(LEAVING_CERTIFICATE_STORE);
      Object.keys(leavingCertificateData).forEach((serialNo) => {
        const data = leavingCertificateData[serialNo];
        store.put({ serialNo, ...data });
      });
      transaction.oncomplete = () => {
        console.log("Leaving certificate data stored successfully");
      };
      transaction.onerror = (e) => {
        console.error("Error storing leaving certificate data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for leaving certificate data:", error);
    }
  };

  const storeBonafideCertificateData = async (BonafideCertificateData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(BONAFIDE_CERTIFICATE_STORE, "readwrite");
      const store = transaction.objectStore(BONAFIDE_CERTIFICATE_STORE);
      Object.keys(BonafideCertificateData).forEach((serialNo) => {
        const data = BonafideCertificateData[serialNo];
        store.put({ serialNo, ...data });
      });
      transaction.oncomplete = () => {
        console.log("BonafideCertificateData certificate data stored successfully");
      };
      transaction.onerror = (e) => {
        console.error("Error storing BonafideCertificateData certificate data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for BonafideCertificateData certificate data:", error);
    }
  };


  // Add new useEffect for fetching departments
useEffect(() => {
  const fetchDepartmentOptions = async () => {
    if (udiseNumber) {
      try {
        const departmentResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizeUdise(udiseNumber)}/department.json`
        );
        const departmentData = await departmentResponse.json();

        if (departmentResponse.ok && departmentData) {
          const departments = Object.keys(departmentData);
          setDepartmentOptions(departments);
          if (departments.length === 1) {
            setDepartment(departments[0]);
          } else {
            setDepartment('');
          }
        } else {
          setDepartmentOptions([]);
          setDepartment('');
        }
      } catch (error) {
        console.error("Error fetching department options:", error);
        setDepartmentOptions([]);
        setDepartment('');
      }
    } else {
      setDepartmentOptions([]);
      setDepartment('');
    }
  };

  fetchDepartmentOptions();
}, [udiseNumber]);


  useEffect(() => {
    const fetchUdiseOptions = async () => {
      if (mobileNumber.length === 10) {
        try {
          const userResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`
          );
          const userData = await userResponse.json();
  
          if (userResponse.ok && userData) {
            const udiseList = [];
  
            if (userData.udiseNumber) {
              udiseList.push(normalizeUdise(userData.udiseNumber));
            }
  
            const udiseOptionsFromData = Object.values(userData)
              .filter((entry) => entry.udiseNumber)
              .map((entry) => normalizeUdise(entry.udiseNumber));
  
            const allUdiseOptions = [...new Set([...udiseList, ...udiseOptionsFromData])];
            setUdiseOptions(allUdiseOptions);
  
            if (allUdiseOptions.length === 1) {
              setUdiseNumber(allUdiseOptions[0]);
            }
          } else {
            setUdiseOptions([]);
          }
        } catch (error) {
          console.error("Error fetching UDISE options:", error);
          setUdiseOptions([]);
        }
      } else {
        setUdiseOptions([]);
      }
    };
  
    fetchUdiseOptions();
  }, [mobileNumber]);

const handleDepartmentChange = async (e) => {
  const selectedDept = e.target.value;
  setDepartment(selectedDept);
  
  try {
    // Fetch the complete school data
    const schoolResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${String(udiseNumber)}/schoolData.json`
    );
    const schoolData = await schoolResponse.json();
    
    if (schoolResponse.ok && schoolData) {
      // Store only the selected department's data
      await storeSchoolData(schoolData, selectedDept);
      
      // Update UI with department-specific data
      if (selectedDept && schoolData.department && schoolData.department[selectedDept]) {
        const deptData = schoolData.department[selectedDept];
        setSchoolName(deptData.schoolName || schoolData.schoolName);
        setSchoolLogo(deptData.schoolLogo || schoolData.schoolLogo);
        setschoollanguage(deptData.language || schoolData.language || "English");
      } else {
        // Fallback to base school data if no department selected or no department data
        setSchoolName(schoolData.schoolName);
        setSchoolLogo(schoolData.schoolLogo);
        setschoollanguage(schoolData.language || "English");
      }
    }
  } catch (error) {
    console.error("Error fetching department data:", error);
  }
};

const fetchSchoolData = async () => {
  await clearIndexedDB();
  if (mobileNumber.length === 10 && udiseNumber) {
    try {
      let schoolDataToStore = null;
      
      // 1. Try to fetch department data first if selected
      if (department) {
        const deptResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData/department/${department}.json`
        );
        
        if (deptResponse.ok) {
          const deptData = await deptResponse.json();
          if (deptData) {
            schoolDataToStore = {
              udiseNumber,
              schoolName: deptData.schoolName || "",
              address: deptData.address || "",
              taluka: deptData.taluka || "",
              jilha: deptData.jilha || "",
              email: deptData.email || "",
              boardName: deptData.boardName || "",
              boardType: deptData.boardType || "",
              madhyam: deptData.madhyam || "",
              mobileNumber: deptData.mobileNumber || "",
              sansthaName: deptData.sansthaName || "",
              schoolLogo: deptData.schoolLogo || "",
              schoolLogo2: deptData.schoolLogo2 || "",
              signature: deptData.signature || "",
              manyataKramank: deptData.manyataKramank || "",
              indexNumber: deptData.indexNumber || "",
              schoolCode: deptData.schoolCode || "",
              sanlagnataKramank: deptData.sanlagnataKramank || "",
              state: deptData.state || "",
              telephoneNumber: deptData.telephoneNumber || "",
              department: department,
              isDepartmentData: true
            };
            
            // Update UI
            setSchoolName(deptData.schoolName || "");
            setSchoolLogo(deptData.schoolLogo || "");
            setschoollanguage(deptData.language || "English");
          }
        }
      }
      
      // 2. If no department data, fetch main school data
      if (!schoolDataToStore) {
        const schoolResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
        );
        
        if (schoolResponse.ok) {
          const schoolData = await schoolResponse.json();
          if (schoolData) {
            schoolDataToStore = {
              udiseNumber,
              schoolName: schoolData.schoolName || "",
              address: schoolData.address || "",
              taluka: schoolData.taluka || "",
              jilha: schoolData.jilha || "",
              email: schoolData.email || "",
              boardName: schoolData.boardName || "",
              boardType: schoolData.boardType || "",
              madhyam: schoolData.madhyam || "",
              mobileNumber: schoolData.mobileNumber || "",
              sansthaName: schoolData.sansthaName || "",
              schoolLogo: schoolData.schoolLogo || "",
              schoolLogo2: schoolData.schoolLogo2 || "",
                            signature: schoolData.signature || "", // Add signature field

              manyataKramank: schoolData.manyataKramank || "",
              indexNumber: schoolData.indexNumber || "",
              schoolCode: schoolData.schoolCode || "",
              sanlagnataKramank: schoolData.sanlagnataKramank || "",
              state: schoolData.state || "",
              telephoneNumber: schoolData.telephoneNumber || "",
              department: 'Main',
              isDepartmentData: false
            };
            
            // Update UI
            setSchoolName(schoolData.schoolName || "");
            setSchoolLogo(schoolData.schoolLogo || "");
            setschoollanguage(schoolData.language || "English");
          }
        }
      }
      
      // 3. Store the data if we have it
      if (schoolDataToStore) {
        console.log("Storing school data:", schoolDataToStore);
        await storeSchoolData(schoolDataToStore);
      } else {
        console.warn("No school data found for UDISE:", udiseNumber);
        setSchoolName("");
        setSchoolLogo("");
      }
      
    } catch (error) {
      console.error("Error fetching school data:", error);
      setSchoolName("");
      setSchoolLogo("");
    }
  } else {
    setSchoolName("");
    setSchoolLogo("");
  }
};
  
   useEffect(() => {
  if (udiseNumber) {
    fetchSchoolData();
  }
}, [udiseNumber, department]);

    const createClassDiv = async () => {
      try {
        const db = await initializeDB();
        const transaction = db.transaction(STUDENT_STORE, "readonly");
        const store = transaction.objectStore(STUDENT_STORE);
        
        // Create a promise to handle the request
        const students = await new Promise((resolve, reject) => {
          const request = store.getAll(); // Fetch all student data
    
          request.onsuccess = (event) => {
            resolve(event.target.result); // Resolve with the result
          };
    
          request.onerror = (event) => {
            reject("Error fetching students: " + event.target.error); // Reject on error
          };
        });
    
        const classDiv = {};
    
        students.forEach(student => {
          const { currentClass, division } = student;
    
          if (!classDiv[currentClass]) {
            // If no division, set to true; if division exists, create an object
            classDiv[currentClass] = division ? { [division]: true } : true; 
          } else {
            // If class already exists, check if it's an object
            if (typeof classDiv[currentClass] === 'object') {
              // If division exists, add it to the existing object
              if (division) {
                classDiv[currentClass][division] = true; // Add division to existing class
              }
            } else {
              // If class is true (no divisions), convert it to an object
              if (division) {
                classDiv[currentClass] = { [division]: true }; // Create an object with the division
              }
            }
          }
        });
    
        // Store the organized classDiv in localStorage
        localStorage.setItem("classDiv", JSON.stringify(classDiv));
      } catch (error) {
        console.error("Error creating classDiv:", error);
      }
    };

const handleLogin = async (e) => {
  e.preventDefault();
  setSavingData(true);
  try {
    const userResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`
    );
    const userData = await userResponse.json();

    if (!userResponse.ok || !userData) {
      setErrorMessage(
        language === "English"
          ? "Mobile number is not registered."
          : "मोबाईल नंबर नोंदणीकृत नाही."
      );
      setSavingData(false);
      return;
    }

    // Normalize the input UDISE number
    const normalizedInputUdise = normalizeUdise(udiseNumber);

    // Find matching user data by comparing normalized UDISE numbers
    const selectedUserData =
      Object.values(userData).find((data) => 
        normalizeUdise(data.udiseNumber) === normalizedInputUdise
      ) ||
      (normalizeUdise(userData.udiseNumber) === normalizedInputUdise ? userData : null);

    if (!selectedUserData) {
      setErrorMessage(
        language === "English"
          ? "Mobile number is incorrect or not found."
          : "मोबाइल नंबर अयोग्य किंवा सापडला नाही."
      );
      setSavingData(false);
      return;
    }

    if (selectedUserData.password !== password) {
      setErrorMessage(
        language === "English" ? "Incorrect password." : "अयोग्य पासवर्ड."
      );
      setSavingData(false);
      return;
    }

    // Fetch admin data to check plan status
    const adminResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${normalizedInputUdise}.json`
    );
    const adminData = await adminResponse.json();

    if (!adminResponse.ok || !adminData) {
      setErrorMessage(
        language === "English"
          ? "Unable to verify account status. Please contact support."
          : "खाते स्थिती सत्यापित करण्यात अक्षम. कृपया समर्थनाशी संपर्क साधा."
      );
      setSavingData(false);
      return;
    }

    // Check if account is active
    if (adminData.userStatus?.toLowerCase() !== "active") {
      alert(
        language === "English"
          ? "Your account is not active. Please contact our team to activate your plan."
          : "तुमचे खाते सक्रिय नाही. कृपया आमच्या टीमशी संपर्क साधा."
      );

      // console.log("normalizedInputUdise",normalizedInputUdise);
      
      // navigate("/plans-for-user", { 
      //   state: { 
      //     udiseNumber: normalizedInputUdise 
      //   }
      // });
      setSavingData(false);
      return;
    }


      // Fetch department classes from Firebase
      let allowedClasses = [];
      if (department) {
        // Specific department selected 
        const departmentResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/department/${department}.json`
        );
        if (!departmentResponse.ok) {
          throw new Error(`Failed to fetch data for department: ${department}`);
        }
        const departmentData = await departmentResponse.json();

        if (departmentData && typeof departmentData === 'object') {
          allowedClasses = Object.keys(departmentData).map((classKey) =>
            normalizeClassName(classKey)
          ).filter(className => className); // Filter out empty class names
          console.log(`Classes for department ${department}:`, allowedClasses);
        }
      } else if (department === "") {
        // "All" selected - fetch all departments
        const allDepartmentsResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/department.json`
        );
        if (!allDepartmentsResponse.ok) {
          throw new Error('Failed to fetch all departments');
        }
        const allDepartmentsData = await allDepartmentsResponse.json();

        if (allDepartmentsData && typeof allDepartmentsData === 'object') {
          // Collect all unique classes from all departments
          const allClasses = new Set();
          Object.values(allDepartmentsData).forEach((deptData) => {
            if (deptData && typeof deptData === 'object') {
              Object.keys(deptData).forEach((classKey) => {
                const normalizedClass = normalizeClassName(classKey);
                if (normalizedClass) allClasses.add(normalizedClass);
              });
            }
          });
          allowedClasses = Array.from(allClasses);
          console.log('Classes for all departments:', allowedClasses);
        }
      }

    // Check if plan has expired
    const currentDate = new Date();
    const deactivationDate = new Date(adminData.deactivationDate);
    
    if (currentDate > deactivationDate) {
      // Update user status to Deactive in Admin node
      await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${normalizedInputUdise}/userStatus.json`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify("Deactive"),
        }
      );

      alert(
        language === "English"
          ? "Your free trial has expired. Please contact our team to activate your plan."
          : "तुमची विनामूल्य चाचणी कालबाह्य झाली आहे. कृपया आमच्या टीमशी संपर्क साधा."
      );
      setSavingData(false);
      return;
    }

    // Fetch and store student data
    const schoolResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/studentData.json`
    );
    const studentData = await schoolResponse.json();
    if (studentData && typeof studentData === 'object') {
        // Filter student data based on allowed classes if any (specific department or All)
        let filteredStudentData = studentData;
        if (allowedClasses.length > 0) {
          filteredStudentData = Object.fromEntries(
            Object.entries(studentData).filter(([key, student]) => {
              if (student === null) return false;
              // Normalize student.currentClass to match allowedClasses
              const studentClass = normalizeClassName(student.currentClass);
              return allowedClasses.includes(studentClass);
            })
          );
        }


    

        // Log the number of students to be stored for debugging
        console.log(`Storing ${Object.keys(filteredStudentData).length} students in IndexedDB`);

        // Store filtered student data in IndexedDB
        const storeSuccess = await storeStudentData(filteredStudentData);
        if (!storeSuccess) {
          throw new Error('Failed to store student data in IndexedDB');
        }
        await createClassDiv();
      }


       // Store login count and timestamp
const loginCountRef = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolLogin/${normalizedInputUdise}`;
const currentDate2 = new Date().toISOString();
console.log("loginCountRef",loginCountRef);

// Fetch current login count
const loginCountResponse = await fetch(`${loginCountRef}.json`);
const loginCountData = await loginCountResponse.json();
let loginCount = 1; // Default to 1 if no previous logins

console.log("loginCountData", loginCountData);

// Check if there are existing login counts
if (loginCountData) {
  // Extract the keys and convert them to numbers
  const existingCounts = Object.keys(loginCountData).map(Number);
  
  // Find the maximum existing count
  const maxCount = Math.max(...existingCounts);
  
  // Increment the maximum count by 1
  loginCount = maxCount + 1;
}

// Store the new login count and timestamp
await fetch(`${loginCountRef}/${loginCount}.json`, {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ timestamp: currentDate2 }),
});

    const defaultSettingsResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/defaultSettings.json`
    );
    const defaultSettingsData = await defaultSettingsResponse.json();
    
    if (defaultSettingsResponse.ok && defaultSettingsData) {
      await storeDefaultSettingsData(defaultSettingsData);
    }

    const AttendanceResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/Attendance.json`
    );
    const AttendanceData = await AttendanceResponse.json();

    if (AttendanceResponse.ok && AttendanceData) {
      await storeAttendanceData(AttendanceData);
    }

    const inventoryResponse = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/inventory.json`
    );
    const inventoryData = await inventoryResponse.json();
  
    if (inventoryResponse.ok && inventoryData) {
      try {
        await storeInventoryData(inventoryData);
      } catch (error) {
        console.error("Error storing inventory data in IndexedDB:", error);
      }
    }

const storeAttachFeeData = async (attachFeeData) => {
  try {
    const db = await initializeDB();
    const transaction = db.transaction(KIRD_STORE, "readwrite");
    const store = transaction.objectStore(KIRD_STORE);
    
    // Clear existing attachFeeData data
    await store.clear();

    // Transform and store attachFeeData
    Object.keys(attachFeeData).forEach((key) => {
      const data = attachFeeData[key];
      const formattedData = {
        id: key, // Use the key as the id
        kirdType: data.kirdType,
        creditKhate: data.creditKhate,
        debitKhate: data.debitKhate,
        typeofattach: data.typeofattach
      };
      store.put(formattedData);
      console.log(`attachFeeData stored for key: ${key}`);
    });

    transaction.oncomplete = () => {
      console.log("Transaction completed for attachFeeData");
    };

    transaction.onerror = (e) => {
      console.error("Error storing attachFeeData data:", e.target.error);
    };
  } catch (error) {
    console.error("Error initializing DB for attachFeeData data:", error);
  }
};

// In your fetch logic, call storeAttachFeeData with the fetched data
const attachFeeResponse = await fetch(
  `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/kirdWithFeeattach.json`
);
const attachFeedata = await attachFeeResponse.json();

if (attachFeeResponse.ok && attachFeedata) {
  await storeAttachFeeData(attachFeedata);
}



    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/leavedStd.json`
    );
    const leavingCertificateData = await response.json();
    if (response.ok && leavingCertificateData) {
      await storeLeavingCertificateData(leavingCertificateData);
    }

    const responseBona = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/BonafideStd.json`
    );
    const BonafideCertificateData = await responseBona.json();
    if (responseBona.ok && BonafideCertificateData) {
      await storeBonafideCertificateData(BonafideCertificateData);
    }

    const selectedPages = selectedUserData.selectedPages || [];
    const hu = CryptoJS.SHA256(String(selectedUserData.udiseNumber)).toString();
    const userStatus2 = selectedUserData.status;
    const editable = selectedUserData.editable || false;
    
    // Store essential data in localStorage
    localStorage.setItem("hu", hu);
    localStorage.setItem("udiseNumber", normalizedInputUdise);
    localStorage.setItem("language", language);
    localStorage.setItem("userStatus", userStatus2);
    localStorage.setItem("mobile", mobileNumber);
    localStorage.setItem("selectedPages", JSON.stringify(selectedPages));
    localStorage.setItem("department", department === "" ? "All" : department);  // New
    localStorage.setItem("editable", String(editable));

    
    setSavingData(false);
    navigate("/home");
  } catch (error) {
    console.error("Error logging in:", error);
    setErrorMessage(
      language === "English"
        ? "An error occurred while logging in. Please try again later."
        : "लॉगिन करताना त्रुटी आली. कृपया नंतर पुन्हा प्रयत्न करा."
    );
    setSavingData(false);
  }
};

const selectStyle = {
  width: '100%',
  padding: '0.3rem 0.4rem',
  borderRadius: '10px',
  border: '2px solid #e5e7eb',
  transition: 'all 0.3s ease',
  fontSize: '1rem',
  outline: 'none',
  backgroundColor: 'white'
};
  
  const backgroundElementsStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: 0,
    pointerEvents: 'none'
  };

  const circleStyle = (size, color, delay, duration) => ({
    position: 'absolute',
    width: size,
    height: size,
    backgroundColor: color,
    borderRadius: '50%',
    opacity: 0.15,
    animation: `floatCircle ${duration}s ease-in-out infinite`,
    animationDelay: `${delay}s`
  });

  const squareStyle = (size, color, delay, duration) => ({
    position: 'absolute',
    width: size,
    height: size,
    backgroundColor: color,
    opacity: 0.15,
    animation: `rotateSquare ${duration}s linear infinite`,
    animationDelay: `${delay}s`
  });

  const containerStyle = {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const formCardStyle = {
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    padding: '1rem',
    maxWidth: '800px',
    width: '100%',
    transform: 'translateY(0)',
    transition: 'all 0.3s ease',
    animation: 'fadeIn 0.5s ease-out',
    margin: '0 auto'
  };

  const formRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '1rem -1rem',
    alignItems: 'center'
  };

  const logoColumnStyle = {
    flex: '1',
    minWidth: '300px',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  const formColumnStyle = {
    flex: '2',
    minWidth: '300px',
    padding: '1rem',
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: 'red',
    marginBottom: '0.5rem',
    textAlign: 'center',
    animation: 'slideDown 0.5s ease-out'
  };

  const schoolNameStyle = {
    fontSize: '1.6rem',
    color: '#4f46e5',
    marginTop: '1rem',
    textAlign: 'center',
    fontWeight: 'bold',
  };

  const inputContainerStyle = {
    marginBottom: '1rem'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    color: '#374151',
    fontWeight: '500'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.3rem 0.4rem',
    borderRadius: '10px',
    border: '2px solid #e5e7eb',
    transition: 'all 0.3s ease',
    fontSize: '1rem',
    outline: 'none'
  };

  const buttonStyle = {
    width: '100%',
    padding: '0.4rem 1rem',
    borderRadius: '10px',
    backgroundColor: '#4f46e5',
    color: 'white',
    border: 'none',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '1rem',
    transform: 'translateY(0)',
    boxShadow: '0 4px 6px rgba(79, 70, 229, 0.2)'
  };

  const errorStyle = {
    color: '#ef4444',
    marginTop: '0.5rem',
    fontSize: '0.875rem',
    animation: 'shake 0.5s ease-in-out'
  };

  const linkContainerStyle = {
    textAlign: 'center',
    marginTop: '1rem'
  };

  const linkStyle = {
    color: '#4f46e5',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'color 0.3s ease'
  };

  const imageStyle = {
    width: '100%',
    maxWidth: '200px',
    height: 'auto',
    borderRadius: '15px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    animation: 'pulse 2s infinite',
    marginBottom: '3rem'
  };

  
  return (
    <div style={containerStyle} className="login-container">
    <style>
      {`
        .login-container {
          padding: 2rem;
        }

        /* Keep all your existing animations */
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }

        @keyframes floatCircle {
          0% { transform: translate(0, 0) rotate(0deg); }
          33% { transform: translate(30px, -50px) rotate(120deg); }
          66% { transform: translate(-20px, 20px) rotate(240deg); }
          100% { transform: translate(0, 0) rotate(360deg); }
        }

        @keyframes rotateSquare {
          0% { transform: rotate(0deg) scale(1); }
          50% { transform: rotate(180deg) scale(1.2); }
          100% { transform: rotate(360deg) scale(1); }
        }

        /* Add responsive styles */
        @media (max-width: 768px) {
          .login-container {
            padding: 1rem;
          }

          .form-card {
            width: 95%;
            padding: 1.5rem;
            margin: 1rem;
          }

          .form-row {
            flex-direction: column;
          }

          .logo-column {
            width: 100%;
            min-width: 100% !important;
            margin-bottom: 1rem;
          }

          .form-column {
            width: 100%;
            min-width: 100% !important;
          }

          .school-logo {
            max-width: 150px;
          }
        }

        /* Keep your existing input and button styles */
        input:focus {
          border-color: #4f46e5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.2);
        }

        button:hover {
          background-color: #4338ca;
          transform: translateY(-2px);
          box-shadow: 0 6px 8px rgba(79, 70, 229, 0.3);
        }

        button:active {
          transform: translateY(0);
        }
      `}
    </style>
    {savingData && <img width={'100px'} style={{zIndex:'99999'}} className="registerLoading" src={loadingspinner} />}

    {/* Keep your existing animated background elements */}
    <div style={backgroundElementsStyle}>
      <div style={{...circleStyle('150px', '#8b5cf6', 0, 20), top: '10%', left: '18%'}} />
      <div style={{...circleStyle('100px', '#6366f1', 2, 15), top: '70%', left: '10%'}} />
      <div style={{...circleStyle('200px', '#3b82f6', 1, 25), top: '40%', right: '15%'}} />
      <div style={{...squareStyle('120px', '#7c3aed', 3, 18), top: '20%', right: '5%'}} />
      <div style={{...squareStyle('80px', '#4f46e5', 2, 22), bottom: '15%', right:'10%'}} />
      <div style={{...squareStyle('160px', '#2563eb', 4, 20), top: '60%', left: '5%'}} />


      <div style={{...squareStyle('160px', '#2563eb', 8, 40), top: '15%', left: '5%'}} />
      <div style={{...circleStyle('200px', '#3b82f6', 1, 25), top: '70%', right: '5%'}} />
    </div>

    {/* Form card with responsive classes */}
    <div style={{...formCardStyle}} className="form-card">
      <h1 style={titleStyle}>{language === 'English' ? 'School Login' : 'स्कूल लॉगिन'}</h1>
      
      {schoolName && <div style={schoolNameStyle}>{schoolName}</div>}
      
      <div style={formRowStyle} className="form-row">
        <div style={logoColumnStyle} className="logo-column">
          <img
            style={imageStyle}
            className="school-logo"
            src={schoolLogo || schoolImage}
            alt="School"
          />
        </div>
        
        <div style={formColumnStyle} className="form-column">
          <form onSubmit={handleLogin}>
            {/* Keep your existing form content unchanged */}
            <div style={inputContainerStyle}>
              <label style={labelStyle} htmlFor="mobileNumber">
                {language === 'English' ? 'Mobile Number:' : 'मोबाईल नंबर:'}
              </label>
              <input
                style={inputStyle}
                maxLength={10}
                type="text"
                id="mobileNumber"
                value={mobileNumber}
                onChange={e => setMobileNumber(e.target.value)}
              />
            </div>
          {udiseOptions.length > 1 && (
<div>
<label>UDISE Number:</label>
<select
value={udiseNumber}
onChange={(e) => setUdiseNumber(e.target.value)}
required
>
<option value="">Select UDISE Number</option>
{udiseOptions.map((option) => (
<option key={option} value={option}>
{option}
</option>
))}
</select>
</div>
)}
{departmentOptions.length > 0 && (
  <div style={inputContainerStyle}>
    <label style={labelStyle} htmlFor="department">
      {language === "English" ? "Department:" : "विभाग:"}
    </label>
    <select
      style={selectStyle}
      id="department"
      value={department}
      onChange={handleDepartmentChange}
      required
    >
      {/* Default placeholder option */}
      <option value="" disabled hidden>
        {language === "English" ? "Select Department" : "विभाग निवडा"}
      </option>

      {departmentOptions.map((dept) => (
        <option key={dept} value={dept}>
          {dept}
        </option>
      ))}
    </select>
  </div>
)}


            <div style={inputContainerStyle}>
              <label style={labelStyle} htmlFor="password">
                {language === 'English' ? 'Password:' : 'पासवर्ड:'}
              </label>
              <input
                style={inputStyle}
                type="password"
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>

            {errorMessage && <div style={errorStyle}>{errorMessage}</div>}

            <button style={buttonStyle} type="submit">
              {language === 'English' ? 'Login' : 'लॉगिन'}
            </button>

            <div style={linkContainerStyle}>
              <span>
                {language === 'English' ? 'Not Registered Yet? ' : 'अद्याप नोंदणी झाली नाही? '}
                <Link style={linkStyle} to="/school-register">
                  {language === 'English' ? 'Register' : 'नोंदणी करा'}
                </Link>
                <br/>
                <Link style={linkStyle} to="/forget-password">
                  {language === 'English' ? 'Forget Password?' : 'Forget Password?'}
                </Link>
              </span>
              
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
}

export default LoginForm;